export enum DocumentTypeEnum {
  "RG" = "RG",
  "CPF" = "CPF",
  "CNPJ" = "CNPJ",
  "CTPS" = "CTPS",
  "PIS" = "PIS",
  "NIS" = "NIS",
  "Titulo de Eleitor" = "TITULO_ELEITOR",
  "CRLV" = "CRLV",
  "CNH" = "CNH",
  "Passaporte" = "PASSAPORTE",
  "CREA" = "CREA",
  "OAB" = "OAB",
  "CRM" = "CRM",
  "COREN" = "COREN",
  "CRC" = "CRC",
  "CRP" = "CRP",
  "CORE" = "CORE",
  "CRN" = "CRN",
  "CRF" = "CRF",
  "CRB" = "CRB",
  "Registro no Conselho" = "REGISTRO_CONSELHO",
  "RNE" = "RNE",
  "CREF" = "CREF"
}

